<template>
    <div class="bg-white w-full h-screen fixed z-40 top-0 overflow-auto">
        <nav class="px-3 py-4 pt-7 lg:p-12 h-full">
            <div class="flex justify-between items-start mb-[70px] relative z-10">
                <RouterLink to="/">
                    <AtomFluxLogo color="black"/>
                </RouterLink>

                <div class="flex justify-center absolute top-0 w-full">
                    <MoleculeLocaleSelector></MoleculeLocaleSelector>
                </div>

                <div @click="closeMenu" class="flex">
                    <AtomIcMenu class="is-active" @click="closeMenu" color="black"/>
                </div>
            </div>

            <div class="lg:absolute lg:h-full w-full top-0 left-0 flex flex-col justify-center gap-6 items-center text-3xl sm:text-4xl lg:text-6xl lowercase text-center leading-[35px] sm:leading-[47px] lg:leading-[80px]">
                <div class="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16">
                    <div>
                        <div class="flex flex-col">
                            <div @click="closeMenu">
                                <router-link class="hover:!underline" :to="{name: 'anarchive.grid'}">
                                    {{ $t('pages.anarchive') }}
                                </router-link>
                            </div>

                            <div @click="closeMenu">
                                <router-link class="hover:!underline" :to="{name: 'event.index'}">
                                    {{ $t('pages.events') }}
                                </router-link>
                            </div>

                            <div @click="closeMenu">
                                <router-link class="hover:!underline" :to="{name: 'project.index'}">
                                    {{ $t('pages.projects') }}
                                </router-link>
                            </div>

                            <div @click="closeMenu">
                                <router-link class="hover:!underline" :to="{name: 'video.index'}">
                                    {{ $t('pages.videos') }}
                                </router-link>
                            </div>

                            <div @click="closeMenu" v-if="hasFolders">
                                <router-link class="hover:!underline" :to="{name: 'folder.index'}">
                                    {{ $t('pages.folders') }}
                                </router-link>
                            </div>
                        </div>
                    </div>

                    <div class="flex flex-col gap-8">
                        <div class="flex flex-col">
                            <div @click="closeMenu">
                                <router-link class="hover:!underline" :to="{name: 'about'}">
                                    {{ $t('pages.about') }}
                                </router-link>
                            </div>

                            <div @click="closeMenu">
                                <router-link class="hover:!underline" :to="{name: 'information'}">
                                    {{ $t('pages.information') }}
                                </router-link>
                            </div>
                        </div>

                        <div class="flex flex-col">
                            <div @click="closeMenu">
                                <router-link class="hover:!underline" :to="{name: 'people.index'}">
                                    {{ $t('pages.peoples') }}
                                </router-link>
                            </div>

                            <div @click="closeMenu">
                                <router-link class="hover:!underline" :to="{name: 'partners'}">
                                    {{ $t('pages.partners') }}
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </nav>
    </div>
</template>
<script>
import AtomFluxLogo from "../atoms/AtomFluxLogo.vue";
import AtomIcMenu from "../../layout/atoms/AtomIcMenu.vue";
import {mapActions, mapMutations, mapState} from "vuex";
import MoleculeLocaleSelector from "./MoleculeLocaleSelector.vue";

export default {
    name: 'OrganismMenu',
    components: {
        MoleculeLocaleSelector,
        AtomFluxLogo,
        AtomIcMenu
    },
    created() {
        if (!this.folders.length) {
            this.getFolders();
        }
    },
    methods: {
        ...mapMutations('menu', [
            'closeMenu'
        ]),
        ...mapActions('folder', ['getFolders']),
    },
    computed: {
        ...mapState({
            folders: state => state.folder.folders
        }),

        hasFolders() {
            return !!this.folders.length;
        }
    }
}
</script>
